<template>
  <div class="light-map position-relative" id="light-map" ref="lightMap">
    <slot></slot>
  </div>
</template>
<script>
import { getInformation } from '@/api/home/home';
import AMapLoader from '@amap/amap-jsapi-loader';
import mapMarkerPng from '@/assets/images/home/map-marker.png';

export default {
  name: 'light-map',
  props: {
    projectList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      aMap: null,
      AMap: null,
      infoWin: null,
    };
  },
  // 渲染
  mounted() {
    this.initMap();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    mapStyle() {
      if (this.skinType) {
        return 'light';
      }
      return 'whitesmoke';
    },
  },
  watch: {
    lights(newVal) {
      console.log('newVal', newVal);
    },
    mapStyle() {
      if (this.aMap) {
        this.aMap.setMapStyle(`amap://styles/${this.mapStyle}`);
        return;
      }
      this.initMap();
    },
    projectList: {
      deep: true,
      handler() {
        this.initMap();
      },
    },
  },
  methods: {
    loadMap() {
      return AMapLoader.load({
        key: '1dfa55ae723cbbccce8d46379e1a4fd0', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.DistrictSearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: { // 是否加载 AMapUI，缺省不加载
          version: '1.1', // AMapUI 缺省 1.1
          plugins: [], // 需要加载的 AMapUI ui插件
        },
      });
    },
    // 初始化地图
    initMap() {
      this.loadMap().then((AMap) => {
        console.log('initMap');
        this.AMap = AMap;
        this.aMap = new AMap.Map('light-map', {
          resizeEnable: true,
          mapStyle: `amap://styles/${this.mapStyle}`,
          zoom: 4,
        });
        this.addProjectList();
        this.requestDistrictSearch(AMap);
      });
    },
    addProjectList() {
      this.projectList.forEach((project) => {
        this.addProjectMarker(project);
      });
    },
    addProjectMarker(project) {
      const icon = new this.AMap.Icon({
        size: new this.AMap.Size(20, 30), // 图标尺寸
        image: mapMarkerPng, // Icon的图像
        imageOffset: new this.AMap.Pixel(0, 0),
        imageSize: new this.AMap.Size(20, 30), // 根据所设置的大小拉伸或压缩图片
      });
      const position = new this.AMap.LngLat(project.PorjectLng, project.PorjectLat);
      const marker = new this.AMap.Marker({
        position,
        title: project.ProjectName,
        offset: new this.AMap.Pixel(-10, -30),
        icon,
      });
      marker.on('click', () => {
        this.openInfo(project, position);
      });
      // 将创建的点标记添加到已有的地图实例：
      this.aMap.add(marker);
    },
    openInfo(project, position) {
      if (this.infoWin) {
        this.infoWin.close();
      }
      // 信息窗体的内容
      const container = document.createElement('div');

      const content = [
        `<div><b>${project.ProjectName}</b>`,
        `<div style="padding:0px">建筑面积: ${project.ProjectArea}㎡`,
        `容量 : ${project.RiongLiang}kVA`,
        `电话 : ${project.ProjectTel}`,
        `地址 : ${project.ProjectAddress}</div></div>`,
      ];
      container.style.color = '#000000';
      container.innerHTML = content.join('<br>');
      const largeScreenCotainer = document.createElement('div');
      largeScreenCotainer.className = 'd-flex justify-content-end';
      const linkButton = document.createElement('a');
      linkButton.href = '#';
      linkButton.innerText = '大屏';
      linkButton.onclick = () => {
        window.open(project.F_ItemURL);
      };
      largeScreenCotainer.appendChild(linkButton);
      container.appendChild(largeScreenCotainer);
      // 创建 infoWindow 实例
      this.infoWin = new this.AMap.InfoWindow({
        content: container, // 传入 dom 对象，或者 html 字符串
        offset: new this.AMap.Pixel(0, -30),
      });
      // 打开信息窗体
      this.infoWin.open(this.aMap, position);
    },
    openNewTab(url) {
      window.open(url);
    },
    requestDistrictSearch(AMap) {
      const districtSearch = new AMap.DistrictSearch({
        level: 'city',
        //  显示下级行政区级数，1表示返回下一级行政区
        subdistrict: 3,
        extensions: 'all',
      });
      Promise.all(this.getSearchDistictList(districtSearch)).then((list) => {
        list.forEach((res) => {
          this.addPolygon(res);
        });
      }).catch((err) => {
        console.log('err', err);
      });
    },
    getSearchDistictList(districtSearch) {
      return this.projectList.filter((project) => project.AreaName).map(
        (project) => this.searchDistict(districtSearch, project.AreaName),
      );
    },
    searchDistict(districtSearch, keyword) {
      return new Promise((resolve, reject) => {
        districtSearch.search(keyword, (status, result) => {
          if (status === 'complete') {
            resolve(result);
          } else {
            reject(result);
          }
        });
      });
    },
    // 请求亮点信息
    requestLigts() {
      getInformation().then((res) => {
        console.log(res);
      });
    },
    // 设置亮点In Map
    setLightsInMap() {

    },
    // 设置单个点亮位置
    setLight() {

    },
    addPolygon(result) {
      const polygons = [];
      const bounds = result.districtList[0].boundaries;
      if (bounds) {
        for (let i = 0, l = bounds.length; i < l; i += 1) {
          // 生成行政区划polygon
          const polygon = new this.AMap.Polygon({
            strokeWeight: 1,
            path: bounds[i],
            fillOpacity: 0.4,
            fillColor: '#C1D4F6',
            strokeColor: '#C1D4F6',
          });
          polygons.push(polygon);
        }
      }
      this.aMap.add(polygons);
      // map.setFitView(polygons);// 视口自适应
    },
    addCircleMarker(result) {
      const circleMarker = new this.AMap.CircleMarker({
        center: result.districtList[0].center,
        radius: 4, // 3D视图下，CircleMarker半径不要超过64px
        strokeColor: '#FFFFFF',
        strokeWeight: 2,
        strokeOpacity: 1,
        fillColor: '#64B0FF',
        fillOpacity: 0.8,
        zIndex: 10,
        bubble: true,
        cursor: 'pointer',
        clickable: true,
        title: result.districtList[0].name,
      });
      circleMarker.setMap(this.aMap);
    },
  },
};
</script>
<style scoped>

</style>
